exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scale-popper-cls {\n  /*width: 390px;*/\n  width: 20vw;\n  padding: 0.078125rem;\n  /*transform: scale(0.8);*/\n  /*-webkit-transform: scale(0.8);*/\n  box-shadow: 0 0.010417rem 0.0625rem 0 rgba(0, 0, 0, 0.5) !important;\n}\n.engagement-info-popover {\n  line-height: 0.125rem !important;\n  padding: 0.026042rem 0.026042rem !important;\n  background-color: #00338d !important;\n  color: white !important;\n  font-size: 0.0625rem !important;\n}\n.engagement-info-popover .popper__arrow::after {\n  border-right-color: #00338d !important;\n  border-left-color: #00338d !important;\n}", ""]);

// exports
